import styled from "styled-components";

export const BasicTableStyle = styled.div`
  background-color: #fff;
  border-radius: 10px;
  .table-scroll {
    height: calc(100vh - 180px);
    overflow: auto;
  }
  table {
    thead {
      td {
        position: sticky;
        top: 0px;
        border-radius: 10px;
        padding: 18px 16px;
        background-color: #fff;
        z-index: 1;
      }
    }
    tbody {
      position: relative;
      border-top: none !important;
    }
    td {
      padding: 6px 16px;
      vertical-align: middle;
      font-size: 15px;
      color: #313949;
      border-bottom: 1px solid #e3e3e3;
    }
    .data-not-found {
      position: absolute;
      top: 50px;
      left: 50%;
      margin-left: -64px;
      font-size: 17px;
    }
  }
`;
